import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-list-card',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="content"><ng-content /></div>
    <rt-icon name="open-in-new" class="hover-affordance" />
    @if (url(); as href) {
      <a
        class="open-link"
        [href]="href"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="label()"
      ></a>
    }
  `,
  styleUrl: './list-card.component.less',
  host: {
    '[class.interactive]': '!!url()',
  },
})
export class ListCardComponent {
  public readonly url = input<string | null>(null);
  public readonly label = input<string | null>(null);
}
